import { Spinner } from 'react-bootstrap';
import useDevSetup from './useDevSetup';
import { AlertMessage } from '../../../../components/ui/AlertMessage/AlertMessage';
import { AlertStatus } from '../../../../components/ui/AlertMessage/AlertStatus';
import { Helpers } from '../../../../utils/helpers';

export const DevSetup = () => {
  const setup = useDevSetup();

  if (!setup.isRunningLocal) return <></>;

  return (
    <div>
      <h1>Local Environment Setup</h1>
      <p>Set up your local development administrator account.</p>
      <AlertMessage
        status={AlertStatus.ERROR}
        message={setup.setupMessage}
        visible={!Helpers.isNullOrWhiteSpace(setup.setupMessage)}
      />
      <div className="form-group mt-3">
        <label htmlFor="email">Email</label>
        <input
          type="email"
          disabled={setup.loading}
          className="form-control"
          id="email"
          value={setup.devSetupRequest.email}
          autoFocus={true}
          onChange={(e) => setup.updateEmail(e.currentTarget.value)}
        />
      </div>
      <div className="form-group">
        <label htmlFor="userName">Password</label>
        <input
          type="password"
          disabled={setup.loading}
          className="form-control"
          value={setup.devSetupRequest.password}
          onChange={(e: React.FormEvent<HTMLInputElement>) =>
            setup.updatePassword(e.currentTarget.value)
          }
        />
      </div>
      <div className="mt-2">
        <button
          type="button"
          className="btn btn-primary"
          onClick={(e) => {
            e.preventDefault();
            void setup.createUser();
          }}
          disabled={
            setup.devSetupRequest.password.trim().length === 0 ||
            setup.devSetupRequest.email.trim().length === 0 ||
            setup.loading
          }>
          Create Account
          {setup.loading && <Spinner size="sm" animation="border" className="ms-2" />}
        </button>
      </div>
    </div>
  );
};
